"use strict";var implementation=require("./implementation");module.exports=function(){return Array.prototype.flat||implementation};